import request from '@/utils/request'

// Po Detail Head
export function getSuccessList(param) {
  let data = param
  return request({
    url: `/po/epms4020/getSuccessList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}
